/**
 * OutcomeLegend — the shared key for step-outcome colors. Hovering a
 * chip explains what the analyzer's label actually means, so terms
 * like DEAD END never have to be guessed at.
 */

import {
  humanizeTag,
  KNOWN_OUTCOMES,
  outcomeHelp,
  outcomeFill,
} from "@/components/benchmarks/goldenProcess";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export function OutcomeLegend(): React.JSX.Element {
  return (
    <p className="flex flex-wrap gap-x-4 gap-y-1 font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
      {KNOWN_OUTCOMES.map((outcome) => (
        <Tooltip key={outcome} delayDuration={0}>
          <TooltipTrigger asChild>
            <span className="inline-flex cursor-help items-center gap-1.5">
              <span
                aria-hidden="true"
                className="size-2.5 rounded"
                style={{ backgroundColor: outcomeFill(outcome) }}
              />
              {humanizeTag(outcome)}
            </span>
          </TooltipTrigger>
          <TooltipContent side="top" className="max-w-72">
            <p className="text-xs text-foreground">{outcomeHelp(outcome)}</p>
          </TooltipContent>
        </Tooltip>
      ))}
    </p>
  );
}
